import { Controller } from "@hotwired/stimulus";
import baguetteBox from "baguettebox.js/dist/baguetteBox.js";

export default class extends Controller {
  static targets = ["refreshButton"];

  connect() {
    baguetteBox.run(".gallery", { filter: /.*/i }); // filter enables urls with no extension
  }

  handleError() {
    this.refreshButtonTarget.click();
  }
}
